(() => {
  const nav = () => document.querySelector('.eonix-goal-nav');
  const grid = () => document.querySelector('#product-grid');
  const selectedFromUrl = () => new URLSearchParams(window.location.search).get('objetivo') || 'todos';

  const updateCount = (count) => {
    document.querySelectorAll('[data-eonix-filter-count]').forEach((node) => {
      node.textContent = `${count} ${count === 1 ? 'producto' : 'productos'}`;
    });
  };

  const applyFilter = (goal = 'todos', updateUrl = false) => {
    const currentNav = nav();
    const currentGrid = grid();
    if (!currentNav || !currentGrid) return;

    const selected = goal || 'todos';
    let visibleCount = 0;

    currentGrid.querySelectorAll('.grid__item').forEach((item) => {
      const pill = item.querySelector('[data-eonix-goal]');
      const visible = selected === 'todos' || pill?.dataset.eonixGoal === selected;
      item.hidden = !visible;
      if (visible) visibleCount += 1;
    });

    currentNav.querySelectorAll('[data-eonix-goal-filter]').forEach((filter) => {
      const active = filter.dataset.eonixGoalFilter === selected;
      filter.toggleAttribute('aria-current', active);
      if (active) filter.setAttribute('aria-current', 'true');
    });

    updateCount(visibleCount);

    if (updateUrl) {
      const url = new URL(window.location.href);
      if (selected === 'todos') url.searchParams.delete('objetivo');
      else url.searchParams.set('objetivo', selected);
      url.hash = 'ProductGridContainer';
      window.history.replaceState({}, '', url);
    }
  };

  const init = () => {
    if (!nav() || !grid()) return;
    applyFilter(selectedFromUrl());

    document.addEventListener('click', (event) => {
      const filter = event.target.closest('[data-eonix-goal-filter]');
      if (filter) {
        event.preventDefault();
        applyFilter(filter.dataset.eonixGoalFilter, true);
        document.querySelector('#ProductGridContainer')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }

      const productPill = event.target.closest('[data-eonix-goal]');
      if (productPill && productPill.closest('#product-grid')) {
        event.preventDefault();
        applyFilter(productPill.dataset.eonixGoal, true);
      }
    });

    const productContainer = document.querySelector('#ProductGridContainer');
    if (productContainer) {
      new MutationObserver(() => applyFilter(selectedFromUrl())).observe(productContainer, {
        childList: true,
        subtree: true
      });
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
